import baseService from './apiService';

export async function getToken() {
    const response = await baseService.get('/auth/user');
    return response.data;
}

export async function loginUser(data) {
    const response = await baseService.post('/auth/login', data);
    return response.data;
}

export async function verifyCode(data) {
    const response = await baseService.post('/auth/login/verify', data);
    return response.data;
}

export const resetPassword = async email => {
    const response = await baseService.post('/auth/reset', {
        email
    });
    return response.data;
};

export const newPassword = async data => {
    const response = await baseService.post('/auth/changePassword', data);
    return response.data;
};
